import React, { useState, useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion';
import { Canvas } from 'glsl-canvas-js';
import { Player } from '@lottiefiles/react-lottie-player';
import { isMobile } from 'react-device-detect';

import { ReactComponent as Rabbit } from '../assets/rabbit.svg';
import image from '../assets/image.jpg';
import frame from '../assets/yellow-frame.png';

export default function Home() {

    const [transition, setTransition] = useState(false);

    const canvasOpacityControl = useAnimation();
    const paintingExitControl = useAnimation();

    useEffect(() => {
        const frag = `
                #ifdef GL_ES
                precision highp float;
                #endif
                #define NUM_OCTAVES 5

                float rand(vec2 n) { 
                    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
                }
                
                float noise(vec2 p){
                    vec2 ip = floor(p);
                    vec2 u = fract(p);
                    u = u*u*(3.0-2.0*u);
                    
                    float res = mix(
                        mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
                        mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
                    return res*res;
                }
                
                float fbm(vec2 x) {
                    float v = 0.0;
                    float a = 0.5;
                    vec2 shift = vec2(100);
                    // Rotate to reduce axial bias
                    mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
                    for (int i = 0; i < NUM_OCTAVES; ++i) {
                        v += a * noise(x);
                        x = rot * x * 2.0 + shift;
                        a *= 0.5;
                    }
                    return v;
                }

                uniform float u_time;
                uniform sampler2D image;

                varying vec2 v_texcoord;

                void main () {
                    vec2 uv = v_texcoord;

                    vec2 surface = vec2(
                        mix(-0.05, 0.05, fbm(uv + 0.1 * u_time)), 
                        mix(-0.05, 0.05, fbm(uv + 0.1 * u_time))
                    );
                    uv += refract(vec2(0.0, 0.0), surface, 1.0 / 1.333);

                    gl_FragColor = texture2D(image, uv);
                }
            `
        const canvas = document.querySelector('canvas');
        const options = {
            fragmentString: frag,
            backgroundColor: 'rgba(0.0, 0.0, 0.0, 0.0)',
            alpha: false,
            antialias: true,
            mode: 'flat',
            extensions: ['EXT_shader_texture_lod']
        };
        const glsl = new Canvas(canvas, options);
        glsl.setUniform('image', image);
    }, []);

    return (
            <motion.div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh'}}>
                <motion.div 
                    animate={{ y: -window.innerHeight}}
                    transition={{ duration: 1, delay: 3 }}
                    style={{ zIndex: 3, backgroundColor: '#2b2b2b', width: '100vw', height: '100vh', position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Player
                        autoplay
                        loop
                        src='https://assets9.lottiefiles.com/packages/lf20_qduawsyh.json'
                        style={{ height: '30vh', width: '30vw' }}/>
                </motion.div>
                { !isMobile && <div animate={paintingExitControl} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src={image} style={{ opacity: 1, height: '100%', position: 'absolute', marginTop: '-150px', zIndex: 0}}/>
                    <motion.canvas animate={canvasOpacityControl} id='painting-canvas' style={{ marginTop: '-150px', width: '1200px', height: '950px', position: 'absolute', zIndex: 1 }}/>
                    <img src={frame} style={{ height: '100%', position: 'absolute', zIndex: 2}}/>
                    <Rabbit className='wiggle rabbit-cursor' style={{ height: '10vh', width: '10vw', position: 'absolute', zIndex: 2, marginTop: '38vh'}}
                        onClick={() => {
                            canvasOpacityControl.start({
                                opacity: !transition ? 0 : 1,
                                transition: { duration: 1 }
                            }).then(() => {
                                setTransition(!transition);
                            })
                        }}/>
                </div> }
                { isMobile && <span className='not-mobile-text'> 💩 Use a full size display 💩 </span>}
            </motion.div>
    );
}